import React from "react";
import { useTranslation } from "react-i18next";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";

export default function FAQ() {
    const { t } = useTranslation();

    const faqs = [
        { q: t("landing.faq.q1"), a: t("landing.faq.a1") },
        { q: t("landing.faq.q2"), a: t("landing.faq.a2") },
        { q: t("landing.faq.q3"), a: t("landing.faq.a3") },
        { q: t("landing.faq.q4"), a: t("landing.faq.a4") },
        { q: t("landing.faq.q5"), a: t("landing.faq.a5") },
        { q: t("landing.faq.q6"), a: t("landing.faq.a6") },
        { q: t("landing.faq.q7"), a: t("landing.faq.a7") },
        { q: t("landing.faq.q8"), a: t("landing.faq.a8") },
    ];

    return (
        <section
            id="faq"
            className="scroll-mt-20 border-b-2 border-black bg-white"
            data-testid="faq-section"
        >
            <div className="border-b-2 border-black">
                <div className="mx-auto max-w-[1400px] grid grid-cols-12">
                    <div className="col-span-12 md:col-span-5 border-r-0 md:border-r-2 border-b-2 md:border-b-0 border-black p-8 md:p-12">
                        <span className="font-mono text-xs tracking-[0.25em] uppercase border-2 border-black bg-white px-3 py-1 inline-block">
                            {t("landing.faq.eyebrow")}
                        </span>
                        <h2 className="mt-6 font-display text-4xl md:text-6xl uppercase leading-[0.95] tracking-tighter">
                            {t("landing.faq.headlineLine1")}
                            <br />
                            {t("landing.faq.headlineLine2")}
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-7 p-0">
                        <Accordion
                            type="single"
                            collapsible
                            data-testid="faq-accordion"
                        >
                            {faqs.map((f, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    data-testid={`faq-item-${i}`}
                                    className="border-b-2 border-black last:border-b-0"
                                >
                                    <AccordionTrigger className="px-8 md:px-12 py-6 hover:no-underline font-mono text-sm md:text-base text-left uppercase tracking-tight">
                                        <span className="flex items-baseline gap-4">
                                            <span className="font-display text-zinc-400 text-base">
                                                {String(i + 1).padStart(2, "0")}
                                            </span>
                                            <span>{f.q}</span>
                                        </span>
                                    </AccordionTrigger>
                                    <AccordionContent className="px-8 md:px-12 pb-6 text-sm leading-relaxed text-zinc-700 max-w-2xl">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
